module.exports = __webpack_public_path__ + "img/fields-history-preview.741d942d.png";